module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-10.fe2a1bd9.png";